import TileLoader from './TileLoader';
import './TileLoader.scss';

export default TileLoader;